import React, { useEffect } from 'react'
import { useFormikContext } from 'formik'
import { toast } from 'react-hot-toast'

import { getFieldErrorNames } from '../../utils/utils'

const OfferError: React.FC = () => {
  const { isValid, isValidating, isSubmitting, errors, submitCount } = useFormikContext()

  useEffect(() => {
    if (isValid || isValidating || !isSubmitting) return
    const fieldErrorNames = getFieldErrorNames(errors)
    if (fieldErrorNames.length <= 0) return

    fieldErrorNames.forEach((name) => {
      if (!errors[name]) return
      toast.error(errors[name])
    })

    const element = document.querySelector(`input[name='${fieldErrorNames[0]}']`)
    if (!element) return

    // Scroll to first known error into view
    element.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }, [errors, submitCount]) // eslint-disable-line react-hooks/exhaustive-deps

  return null
}

export default OfferError
